<div class="row">
    <div class="col-md-12">
        <div class="table-responsive table-full table-overflow-visible">
            <table id="table-talent" class="table table-order table-condensed table-context-menu dataTable">
                <thead style="white-space: nowrap;">
                    <tr>
                      @for (columnDefinition of columnDefinitions || []; track $index; let i = $index) {
                        <th>
                          <div [ngStyle]="columnDefinition.columnStyle" (click)="sortData($event, columnDefinition)">
                              <span [ngStyle]="styleHeader">{{columnDefinition.title}}</span>
                              <i [hidden]="!(columnDefinition.sortable && columnDefinition.sortType == columnSort.Asc)"
                                  class="material-icons"
                                  style="vertical-align: middle !important; line-height: 18px; cursor: pointer;">arrow_drop_up</i>
                              <i [hidden]="!(columnDefinition.sortable && columnDefinition.sortType == columnSort.Desc)"
                                  class="material-icons"
                                  style="vertical-align: middle !important; line-height: 18px; cursor:pointer;">arrow_drop_down</i>
                              <div [hidden]="!(columnDefinition.sortable && columnDefinition.sortType == columnSort.None)"
                                  style="display:flex; flex-direction:column; color:lightgray; cursor: pointer;">
                                  <i class="material-icons"
                                      style="vertical-align: middle !important; line-height: 8px;">arrow_drop_up</i>
                                  <i class="material-icons"
                                      style="vertical-align: middle !important; line-height: 4px;">arrow_drop_down</i>
                              </div>
                              <text-filter [index]="i" [columnDefinition]="columnDefinition" [data]="data || []"
                                  (filterUpdated)="filterUpdated()" [lastColumn]="(i + 1) == columnDefinitions.length"></text-filter>
                          </div>
                        </th>
                      }
                    </tr>
                </thead>
                <tbody class="">
                  @for (row of outputData || []; track $index) {
                    <tr>
                      @for (item of row; track $index; let i = $index) {
                        <td class="center-children"
                          [ngStyle]="{'background-color': outputRowStyleSelector(row).backgroundColor}">
                          @switch ((columnDefinitions[i] || {kind: 'none'}).kind) {
                            @case (columnKind.Text) {
                              <span title="{{columnDefinitions[i].title == 'Bucket FD' ? row[5] : ''}}"
                              [ngStyle]="{'color': outputRowStyleSelector(row).cellStyle.length == 0 ? outputRowStyleSelector(row).foregroundColor : outputRowStyleSelector(row).getCellStyle(i).foregroundColor, 'white-space': 'pre-line'}">{{columnDefinitions[i].getDataValue(item)}}</span>
                            }

                            @case (columnKind.PhoneNumber) {
                              <a [ngStyle]="{'white-space':'pre-line'}"
                              href="tel:{{columnDefinitions[i].getDataValue(item)}}">{{columnDefinitions[i].getDataValue(item)}}</a>
                            }

                            @case (columnKind.Email) {
                              <a [ngStyle]="{'white-space':'pre-line'}"
                                href="mailto:{{columnDefinitions[i].getDataValue(item)}}"
                                target="_blank">{{columnDefinitions[i].getDataValue(item)}} </a>
                            }

                            @case (columnKind.Date) {
                              <span
                              [ngStyle]="{'color': outputRowStyleSelector(row).cellStyle.length == 0 ? outputRowStyleSelector(row).foregroundColor : outputRowStyleSelector(row).getCellStyle(i).foregroundColor}">{{columnDefinitions[i].getDataValue(item)}}</span>
                            }

                            @case (columnKind.Number) {
                              <span
                              [ngStyle]="{'color': outputRowStyleSelector(row).cellStyle.length == 0 ? outputRowStyleSelector(row).foregroundColor : outputRowStyleSelector(row).getCellStyle(i).foregroundColor}">{{columnDefinitions[i].getDataValue(item)}}</span>
                            }

                            @case (columnKind.Link) {
                              <div style="margin: 0%;">
                                @if (columnDefinitions[i].getLink(item) != '') {
                                  <a target="_blank"
                                    rel="noopener noreferrer" href="{{columnDefinitions[i].getLink(item)}}"
                                    [ngStyle]="{'color': outputRowStyleSelector(row).cellStyle.length == 0 ? outputRowStyleSelector(row).foregroundColor : outputRowStyleSelector(row).getCellStyle(i).foregroundColor}">{{columnDefinitions[i].getDataValue(item)}}
                                    @if (item.icon) {
                                      <img src="{{columnDefinitions[i].getIcon(item)}}" width="40"
                                        height="30">
                                    }
                                  </a>
                                }

                                @if (columnDefinitions[i].getLink(item) == '') {
                                  <span [ngStyle]="{'color': outputRowStyleSelector(row).cellStyle.length == 0 ? outputRowStyleSelector(row).foregroundColor : outputRowStyleSelector(row).getCellStyle(i).foregroundColor, 'white-space': 'pre-line'}">{{columnDefinitions[i].getDataValue(item)}}</span>
                                }
                              </div>
                            }

                            @case (columnKind.Action) {
                              <datatable-action-cell
                                [actions]="columnDefinitions[i].getDataValue(item).actions"
                                [data]="columnDefinitions[i].getDataValue(item).data"
                                (onAction)="raiseOnCellAction($event)"></datatable-action-cell>
                            }
                          }
                        </td>
                      }
                    </tr>
                  }
                </tbody>
            </table>
        </div>
    </div>
</div>
